import React from 'react'
import ErrorPage from "../../Assetes/Images/mitaobhook_new.png"
import { Link } from 'react-router-dom'
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';

export default function Error404() {
    const lang = useCurrentLocale();
    const { t } = useTranslation();

    return (
      <div className="error-404">
        {/* <img className="error-image" src={ErrorPage} alt="erroe 404" /> */}
        <h4>{t("ERROR_404_TITLE")}</h4>
        <Link to={`/${lang}/`}>{t("ERROR_404_BACK")}</Link>
        <h5>
        {t("ERROR_404_DESCRIPTION")}
        </h5>
      </div>
    );
}
